import snoowrap from "snoowrap"

import perf from "@/utils/perf"

export default {
	_clientPromise: null,
	async logCompletionTime(promise, startTime, name) {
		await promise
		var endTime = performance.now()
		console.log("Promise '" + name + "' took " + (endTime - startTime) + "ms to settle")
	},

	async setupSharedClient(userAgent, clientID, deviceID) {
		var setupClientStart = performance.now() 
		this._clientPromise = snoowrap.fromApplicationOnlyAuth({
			userAgent: userAgent,
			clientId: clientID,
			deviceId: deviceID,
			grantType: snoowrap.grantType.INSTALLED_CLIENT,
			permanent: false
		})
		perf.measurePromiseCompletionTime(this._clientPromise, setupClientStart, "setupClient")
		return this._clientPromise
	},

	getSharedClient() {
		var ret = this._clientPromise
		if (ret === null) {
			ret = Promise.reject("No client setup. Call setupSharedClient prior to calling sharedClient")
		}
		return ret
	}

}